import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import AutocompleteTextField from "../components/autocompleteTextField";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

export default function AutoSetting({ onClose, open, data = {}, index }) {
  const [autoGetBy, setAutoGetBy] = useState("newest");
  const [tags, setTags] = useState(data ? data.tags : []);
  const [category, setCategory] = useState(data ? data.category : null);
  const [duplicatePermission, setDuplicatePermission] = useState(
    data ? data.duplicatePermission : null
  );
  const [pageviewDuration, setPageviewDuration] = useState(
    data ? data.pageviewDuration : null
  );

  const handleClose = () => {
    const returnData = {
      ...data,
      post: null,
      expiredAt: null,
      type: "auto",
      autoGetBy,
      tags: autoGetBy !== "realtime" ? tags : null,
      category: autoGetBy !== "realtime" ? category : null,
      duplicatePermission: duplicatePermission === "true",
      pageviewDuration:
        autoGetBy === "pageview" &&
        pageviewDuration !== "" &&
        parseInt(pageviewDuration, 10) >= 0
          ? parseInt(pageviewDuration, 10)
          : 1,
    };

    onClose(returnData);
  };

  const save = () => {
    handleClose();
  };

  const cancel = () => {
    onClose();
  };

  useEffect(() => {
    setAutoGetBy(data && data.autoGetBy ? data.autoGetBy : "newest");
    setTags(data && data.tags ? data.tags : []);
    setCategory(data && data.category ? data.category : null);
    setPageviewDuration(
      data && data.pageviewDuration ? data.pageviewDuration : null
    );
    setDuplicatePermission(
      data && data.duplicatePermission ? data.duplicatePermission : false
    );
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={cancel}
      aria-labelledby="form-dialog-title"
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle id="form-dialog-title">
        Vị trí {index + 1} - Cài đặt bài viết tự động
      </DialogTitle>
      <DialogContent dividers={true}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Theo</FormLabel>
              <RadioGroup
                aria-label="gender"
                name="gender1"
                value={autoGetBy}
                onChange={(event) => setAutoGetBy(event.target.value)}
              >
                <FormControlLabel
                  value="newest"
                  control={<Radio />}
                  label="Mới nhất"
                />
                <FormControlLabel
                  value="pageview"
                  control={<Radio />}
                  label="Top View"
                />
                <FormControlLabel
                  value="realtime"
                  control={<Radio />}
                  label="Realtime"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <AutocompleteTextField
              label="Nhập tags (nếu có)"
              setValue={setTags}
              defaultValue={data && data.tags && autoGetBy !== "realtime" ? data.tags : []}
              endpoint="tags"
              disabled={autoGetBy === "realtime"}
              multiple={true}
            />

            <AutocompleteTextField
              label="Nhập category (nếu có)"
              setValue={setCategory}
              defaultValue={data && data.category ? data.category : null}
              endpoint="categories"
              labelField="name"
              className="mt-4"
              disabled={autoGetBy === "realtime"}
            />

            <form className="mt-4" noValidate autoComplete="off">
              <TextField
                disabled={autoGetBy !== "pageview"}
                id="time-filter"
                label="Thời gian (ngày trước)"
                defaultValue={pageviewDuration ? pageviewDuration : 1}
                onChange={(event) => setPageviewDuration(event.target.value)}
                type="number"
                variant="outlined"
                error={
                  pageviewDuration === "" || parseInt(pageviewDuration, 10) <= 0
                }
              />
            </form>
            {data && data.showDuplicationSetting && (
              <FormControl className="mt-4" style={{ width: "300px" }}>
                <InputLabel id="duplicate-permission">
                  Được trùng các bài khác
                </InputLabel>
                <Select
                  labelId="duplicate-permission-label"
                  id="duplicate-permission"
                  value={duplicatePermission}
                  onChange={(event) =>
                    setDuplicatePermission(event.target.value)
                  }
                  label="Được trùng các bài khác"
                  disabled={autoGetBy === "realtime"}
                >
                  <MenuItem value="false">Không trùng</MenuItem>
                  <MenuItem value="true">Trùng</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel} color="primary">
          Hủy
        </Button>
        <Button onClick={save} color="primary">
          Lưu
        </Button>
      </DialogActions>
    </Dialog>
  );
}
